import { getCustomerEntryforDropDown } from "../../Service/AllCustomerEntryAPI";
import { getDealerEntryforDropDown } from "../../Service/AllDealerEntryAPI";
import { getDispenserSrNodDropDownList } from "../../Service/DispenserSrNo";
import { getUserEntryforDropDown } from "../../Service/AllUserEntryAPI";
import { getWorkOrderNoDropDown } from "../../Service/AllWorkOrder";


// lets decide when and what to write for microservice api pre
export const getCustomerList = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    var customerName = [];
    await getCustomerEntryforDropDown(headers)
      .then((result) => {
        if (result?.data?.length !== 0) {
          console.log("Customer Name List", result);
          let tempArray = result.data.map((obj) => {
            let Name = obj.split(",");
            return {
              id: `${Name[0]}`,
              value: `${Name[1]}`,
              label: `${Name[1]}`,
            };
          });
          customerName = tempArray;
          console.log("customerName", customerName);
        }
      })
      .catch((error) => {
        console.log("Customer Name List Error", error);
      });
    return customerName;
  } catch (error) {
    console.log(error);
  }
};

export const getDealerList = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    var dealerName = [];
    await getDealerEntryforDropDown(headers)
      .then((result) => {
        if (result?.data?.length !== 0) {
          console.log("Dealer Name List", result);
          let tempArray = result.data.map((obj) => {
            let Name = obj.split(",");
            return {
              id: `${Name[0]}`,
              value: `${Name[1]}`,
              label: `${Name[1]}`,
            };
          });
          dealerName = tempArray;
        }
      })
      .catch((error) => {
        console.log("Dealer Name List Error", error);
      });
    return dealerName;
  } catch (error) {
    console.log(error);
  }
};

export const getServiceEngineerList = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    var serviceEngineerName = [];
    await getUserEntryforDropDown(headers)
      .then((result) => {
        if (result?.data?.length !== 0) {
          console.log("Service Engineer Name List", result.data);
          let tempServiceArray = result.data.map((obj) => {
            let Name = obj.split(",");
            return {
              id: `${Name[0]}`,
              value: `${Name[1]}`,
              label: `${Name[1]}`,
            };
          });
          serviceEngineerName = tempServiceArray;
          console.log("serviceEngineerName", serviceEngineerName);
        }
      })
      .catch((error) => {
        console.log("Service Engineer Name List Error", error);
      });
    return serviceEngineerName;
  } catch (error) {
    console.log(error);
  }
};

export const getWorkOrderNoList = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const status = ["ready to dispatch"];
    var workOrderNo = [];
    await getWorkOrderNoDropDown(status, headers)
      .then((result) => {
        if (result?.data?.length !== 0) {
          console.log("Work Order List", result.data);
          let tempServiceArray = result.data.map((obj) => {
            // let Name = obj.split(",");
            return {
              id: `${obj}`,
              value: `${obj}`,
              label: `${obj}`,
            };
          });
          workOrderNo = tempServiceArray;
          console.log("Work OrderNo DropDown", result);
        }
      })
      .catch((error) => {
        console.log("Work Order List Error", error);
      });
    return workOrderNo;
  } catch (error) {
    console.log(error);
  }
};

export const getDispenserSrNoList = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    // const status = ["ready to install"];
    const status = ["close and ready to install"];
    var dispenserNo = [];
    await getDispenserSrNodDropDownList(status, headers)
      .then((result) => {
        if (result?.data?.length !== 0) {
          console.log("Dispenser Sr No List", result.data);
          let tempServiceArray = result.data.map((obj) => {
            // let Name = obj.split(",");
            return {
              id: `${obj}`,
              value: `${obj}`,
              label: `${obj}`,
            };
          });
          dispenserNo = tempServiceArray;
          console.log("Dispenser Sr No DropDown", result);
        }
      })
      .catch((error) => {
        console.log("Dispenser Sr No List Error", error);
      });
    return dispenserNo;
  } catch (error) {
    console.log(error);
  }
};
